import { Clear, Search } from "@mui/icons-material";
import { Box, Button, IconButton, InputBase } from "@mui/material";
import Paper from "@mui/material/Paper";

import { useTranslation } from "next-i18next";

import React, { useEffect } from "react";

import { useSearchBox } from "react-instantsearch-hooks-web";

const SearchInputBox = () => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const { query, refine, clear } = useSearchBox();
    const [value, setValue] = React.useState(query || "");
    const { t } = useTranslation("search");

    const placeholder = t("search");

    useEffect(() => {
        setValue(query || "");
    }, [query]);

    const handleClear = () => {
        setValue("");
        clear();
    };

    const setSearchValue = () => {
        if (inputRef.current) {
            setValue(inputRef.current.value);
        }
    };

    return (
        <Paper
            onSubmit={(e) => {
                e.preventDefault();

                if (value || value === "") {
                    refine(value);
                }
            }}
            component="form"
            sx={{ display: "flex", alignItems: "center", width: 400, mx: "auto" }}
        >
            <Box sx={{ ml: 1, flex: 0 }}>
                <Search />
            </Box>
            <InputBase
                // label="Search"
                inputRef={inputRef}
                value={value}
                onKeyUp={setSearchValue}
                onChange={setSearchValue}
                sx={{ ml: 1, flex: 1 }}
                inputProps={{
                    inputRef,
                    placeholder
                }}
            />
            <IconButton
                sx={{ mr: 1, ml: 1, flex: 0 }}
                aria-label="menu"
                onClick={handleClear}
                onMouseDown={handleClear}
            >
                <Clear aria-label="clear search input value" />
            </IconButton>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    refine(inputRef?.current?.value || "");
                }}
            >
                Search
            </Button>
        </Paper>
    );
};

export default SearchInputBox;
